import { gql } from '@apollo/client'
import { marketHeroImageFragment } from 'components/MarketHeroSection'

export default gql`
  ${marketHeroImageFragment}
  query marketQuery($slug: String!) {
    marketBySlug(slug: $slug) {
      id
      name
      customerTrucksMapPath
      customerPath
      description {
        html
      }
      longitude
      latitude
      state
      stateFull
      customerTopTrucksPath
      topTrucksEnabled
      marketTopTrucks {
        id
      }
      lots(
        filter: {
          active: true
          privateProperty: false
          or: [{ custom: false }, { locationsThisWeekGte: 1 }]
        }
      ) {
        total
      }
      ...marketHeroImageFragment
    }
    structuredData {
      marketPage(seoName: $slug)
    }
  }
`
